'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function PageHeading($window) {
	'ngInject';

	var service = {
		'getPageHeading': getPageHeading,
		'setPageHeading': setPageHeading
	};

	var pageHeading = '';

	return service;

	function getPageHeading() {
		return pageHeading;
	}

	function setPageHeading(heading) {
		var title = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];

		if (title) {
			$window.document.title = title;
		}

		pageHeading = heading;
	}
}

exports['default'] = PageHeading;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/components/page-heading/page-heading.service.js
 **/